import { DbDoc, WithRef } from "models/FbDoc"

export function toIdMap<T extends { id: string }>(array: T[]): Record<string, T> {
    return array.reduce((acc, val) => ({ ...acc, [val.id]: val }), {})
}
export function dbDocToIdMap<T extends DbDoc<{ id: string }> | WithRef<DbDoc<{ id: string }>>>(array: T[]): Record<string, T> {
    return array.reduce((acc, val) => ({ ...acc, [val.data.id]: val }), {})
}